import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useJournalBookmark } from '../hooks/useJournalBookmark';
import PrivacyNotice from '../components/PrivacyNotice';

const Journal = () => {
    const location = useLocation();
    const { restoreBookmark } = useJournalBookmark();

    // Restore bookmark when user lands on the base /journal route
    useEffect(() => {
        const restore = async () => {
            if (location.pathname === '/journal') {
                await restoreBookmark();
            }
        };
        restore();
    }, [location.pathname, restoreBookmark]);

    // Scroll to top whenever the route changes
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [location.pathname]);

    return (
        <div className="journal-container">
            <PrivacyNotice />
            <Outlet />
        </div>
    );
};

export default Journal;
